import React, { useState } from "react";
import { Link } from "react-router-dom"; // ✅ use Link for internal routes
import "./Footer.css";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ loading: false, success: "", error: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: "", error: "" });

    // Simulate API call (replace with your newsletter API)
    setTimeout(() => {
      setStatus({
        loading: false,
        success: "Your subscription request has been sent. Thank you!",
        error: "",
      });
      setEmail("");
    }, 1500);
  };

  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          {/* Footer About */}
          <div className="col-lg-4 col-md-6 footer-about">
            <Link to="/" className="logo d-flex align-items-center">
              <span className="sitename">ABCD International Family</span>
            </Link>
            <div className="footer-contact pt-3">
              <p>ABCD International Family</p>
              <p>Mumbai, Maharashtra 400052</p>
              <p className="mt-3">
                <strong>Phone:</strong>{" "}
                <span> +91 9324553209, +91 9322503465</span>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <span>abcdinternationalfamily@gmail.com</span>
              </p>
            </div>
            <div className="social-links d-flex mt-4">
              <a
                href="https://www.facebook.com/abcdcompanyofficial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://www.instagram.com/abcdinternationalfamily"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/abcd-international-family"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>

          {/* Useful Links */}
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-details">About us</Link></li>
              <li><Link to="/terms">Terms of service</Link></li>
              <li><Link to="/privacy">Privacy policy</Link></li>
            </ul>
          </div>

          {/* Our Services */}
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/podcast">Podcast</Link></li>
              <li><Link to="/webinar">Webinar</Link></li>
              <li><Link to="/courses">Courses</Link></li>
              <li><Link to="/events">Events</Link></li>
              
            </ul>
          </div>

          {/* Newsletter */}
          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>
              Subscribe to our newsletter and receive the latest news about our
              products and services!
            </p>
            <form onSubmit={handleSubmit} className="php-email-form">
              <div className="newsletter-form">
                <input
                  type="email"
                  name="email"
                  value={email}
                  placeholder="Enter your email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <input
                  type="submit"
                  value="Subscribe"
                  disabled={status.loading}
                />
              </div>
              {status.loading && <div className="loading">Loading</div>}
              {status.error && (
                <div className="error-message">{status.error}</div>
              )}
              {status.success && (
                <div className="sent-message">{status.success}</div>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">ABCD International Family</strong>{" "}
          <span>All Rights Reserved</span>
        </p>
      </div>
    </footer>
  );
}
